<template>
  <div class="user-password-form">
    <a href="#" slot="extra" @click.prevent="handleChangePassword('ChangePasswordForm')" style="position:absolute;right:16px;top:16px">
      <Icon type="ios-loop-strong"></Icon>
      Save
    </a>
    <Form ref="ChangePasswordForm" :model="formDataPassword" :rules="formPasswordRules" label-position="top">
      <FormItem label="Current Password" prop="old_password">
        <Input type="password" v-model="formDataPassword.old_password" class="k-input"/>
      </FormItem>
      <FormItem label="New Password" prop="new_password">
        <Input type="password" v-model="formDataPassword.new_password" class="k-input"/>
      </FormItem>
      <FormItem label="Confirm Password" prop="repeat_new_password">
        <Input type="password" v-model="formDataPassword.repeat_new_password" class="k-input"/>
      </FormItem>
    </Form>
    <Spin size="large" fix v-if="isPasswordSaving"></Spin>
  </div>
</template>

<script>
import { changePassword } from '@/services/account'

export default {
  data () {
    const validatedRepeatPassword = (rule, value, callback) => {
      if (value === '' || value === null) {
        callback(new Error('Please enter your new password again'))
      } else if (value !== this.formDataPassword.new_password) {
        callback(new Error('The two input passwords do not match!'))
      } else {
        callback()
      }
    }
    return {
      isPasswordSaving: false,
      formDataPassword: {
        old_password: null,
        new_password: null,
        repeat_new_password: null

      },
      formPasswordRules: {
        old_password: [
          { required: true, message: 'Please enter your old password', trigger: 'blur' }
        ],
        new_password: [
          { required: true, message: 'Please enter your new password', trigger: 'blur' }
        ],
        repeat_new_password: [
          { validator: validatedRepeatPassword, trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    handleChangePassword (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.isPasswordSaving = true
          changePassword(this.formDataPassword).then(res => {
            this.$Message.success('Password updated successfully')
            this.isPasswordSaving = false
          }).catch(err => {
            console.log('Failed to changed user password: ', err)
            this.$Message.error({
              background: true,
              duration: 5,
              content: err.response.data.message
            })
            this.isPasswordSaving = false
          })
        } else {
          this.$Message.error('Fail!')
        }
      })
    }
  }
}
</script>
